<h1 mat-dialog-title>{{ title }}</h1>

<mat-dialog-content class="dialog-content">
	<p [innerHTML]="text"></p>
</mat-dialog-content>

<mat-dialog-actions>
	<button mat-stroked-button mat-dialog-close>Cancel</button>
	<button mat-flat-button color="warn" [mat-dialog-close]="true" cdkFocusInitial>{{ yesLabel }}</button>
</mat-dialog-actions>
